import { addClass, removeClass, hasClass } from '@utils/domUtils';
import ApexChartsPackage from 'apexcharts';

export default class JobStatistics {
  static selectorString() {
    return '.JobStatistics';
  }

  render(node, props) {
    this.buttonRenderAllClicks = node.querySelector('.button-render-all-clicks');
    this.buttonRenderDailyClicks = node.querySelector('.button-render-daily-clicks');

    this.buttonRenderAllClicks.addEventListener('click', this.switchToAllClicks.bind(this));
    this.buttonRenderDailyClicks.addEventListener('click', this.switchToDailyClicks.bind(this));

    this.renderClicksChart();
    this.renderClicksPerChannelChart();
    this.renderApplicationsChart();
    this.renderApplicationsPerChannelChart();
  }

  renderClicksChart() {
    const options = {
      series: [
        {
          name: 'Seitenaufrufe',
          data: this.getClicksSeriesData(),
        },
      ],
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'],
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: this.props.jobClickData.map(item => item.formattedDay),
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            return parseInt(val);
          },
        },
      },
    };

    const chart = new ApexChartsPackage(
      this.node.querySelector('.clicks-chart-container'),
      options,
    );

    chart.render();

    this.clicksChart = chart;
    this.updateClicksChart();
  }

  renderApplicationsChart() {
    var options = {
      series: [
        {
          name: 'Bewerbungen',
          data: this.props.applicationsData.map(item =>
            item.dataEntry ? item.dataEntry.overallApplications : 0,
          ),
        },
      ],
      chart: {
        height: 350,
        type: 'bar',
        zoom: {
          enabled: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: ['50%'],
          borderRadius: 6,
        },
      },
      legend: {
        show: true,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'],
          opacity: 0.5,
        },
      },
      fill: {
        opacity: 1,
      },
      states: {
        normal: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        hover: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'none',
            value: 0,
          },
        },
      },
      xaxis: {
        categories: this.props.jobClickData.map(item => item.formattedDay),
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            return parseInt(val);
          },
        },
      },
      colors: ['#F64E60'],
    };

    const chart = new ApexChartsPackage(
      this.node.querySelector('.applications-chart-container'),
      options,
    );

    chart.render();
  }

  renderClicksPerChannelChart() {
    const clicksPerChannel = {};

    for (let i = 0; i < this.props.jobClickData.length; i++) {
      const dataEntry = this.props.jobClickData[i].dataEntry;

      if (!dataEntry) {
        continue;
      }

      Object.keys(dataEntry.clickData.publishedChannels)
        .filter(key => key !== 'vonq_campaign')
        .forEach(key => {
          clicksPerChannel[key] = clicksPerChannel[key] || {
            formattedSource: this.props.publishChannels[key].label,
            clickCount: 0,
          };
          clicksPerChannel[key].clickCount = Math.max(
            clicksPerChannel[key].clickCount,
            dataEntry.clickData.publishedChannels[key],
          );
        });

      if (dataEntry.clickData.vonqCampaigns) {
        dataEntry.clickData.vonqCampaigns.forEach(campaign => {
          if (campaign.products) {
            campaign.products.forEach(product => {
              clicksPerChannel[product.productId] = clicksPerChannel[product.productId] || {
                formattedSource: product.title,
                clickCount: 0,
              };
              clicksPerChannel[product.productId].clickCount = Math.max(
                clicksPerChannel[product.productId].clickCount,
                product.clicks,
              );
            });
          }
        });
      }
    }

    const options = {
      series: Object.keys(clicksPerChannel)
        .filter(key => clicksPerChannel[key].clickCount > 0)
        .map(key => clicksPerChannel[key].clickCount),
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: Object.keys(clicksPerChannel)
        .filter(key => clicksPerChannel[key].clickCount > 0)
        .map(key => clicksPerChannel[key].formattedSource),
    };

    const chart = new ApexChartsPackage(
      this.node.querySelector('.clicks-per-channel-chart-container'),
      options,
    );

    chart.render();
  }

  renderApplicationsPerChannelChart() {
    const applicationsPerChannel = this.props.applicationsData.reduce(
      (result, item) =>
        item.dataEntry
          ? {
              ...result,
              ...item.dataEntry.applications.reduce(
                (result2, entry) => ({
                  ...result2,
                  [entry.source]: {
                    formattedSource: entry.formattedSource,
                    applicationCount:
                      (result2[entry.source] ? result2[entry.source].applicationCount : 0) +
                      entry.applications,
                  },
                }),
                result,
              ),
            }
          : result,
      {},
    );

    const options = {
      series: Object.keys(applicationsPerChannel).map(
        key => applicationsPerChannel[key].applicationCount,
      ),
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: Object.keys(applicationsPerChannel).map(
        key => applicationsPerChannel[key].formattedSource,
      ),
    };

    const chart = new ApexChartsPackage(
      this.node.querySelector('.applications-per-channel-chart-container'),
      options,
    );

    chart.render();
  }

  switchToAllClicks() {
    addClass(this.buttonRenderAllClicks, 'btn-primary');
    removeClass(this.buttonRenderAllClicks, 'btn-secondary');

    removeClass(this.buttonRenderDailyClicks, 'btn-primary');
    addClass(this.buttonRenderDailyClicks, 'btn-secondary');

    this.updateClicksChart();
  }

  switchToDailyClicks() {
    removeClass(this.buttonRenderAllClicks, 'btn-primary');
    addClass(this.buttonRenderAllClicks, 'btn-secondary');

    addClass(this.buttonRenderDailyClicks, 'btn-primary');
    removeClass(this.buttonRenderDailyClicks, 'btn-secondary');

    this.updateClicksChart();
  }

  updateClicksChart() {
    if (!this.clicksChart) {
      return;
    }

    this.clicksChart.updateSeries([
      {
        name: 'Seitenaufrufe',
        data: this.getClicksSeriesData(),
      },
    ]);
  }

  getClicksSeriesData() {
    let overallClicks = 0;

    const overallClicksPerDay = this.props.jobClickData.map(item => {
      overallClicks = item.dataEntry ? item.dataEntry.clickData.overallClicks : overallClicks;
      return overallClicks;
    });

    if (hasClass(this.buttonRenderDailyClicks, 'btn-primary')) {
      return overallClicksPerDay.map((clicks, index) =>
        index === 0 ? clicks : clicks - overallClicksPerDay[index - 1],
      );
    }

    return overallClicksPerDay;
  }
}
